<a href="javascript:;" [class.active]="lang.code == userLanguageCtrl.value"
        (click)="onChangeLang(lang.code)"
        *ngFor="let lang of languages">
  {{lang.name}}
</a>
